import { useIsLoggedIn, useSelectedThemeColor } from '../../../store/appStore';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { BI_CONSTANTS } from '../../../hooks/useBiLogger/biConstants';
import { useSpec } from '../../../hooks/useSpec';
import { SelectThemeFirst } from '../../../experiments';
import { APP_ROOT_URL, STORE_NAME_URL } from '../../../consts';

export const useTemplateNavigation = () => {
  const selectedThemeColor = useSelectedThemeColor();
  const { navigate } = useAppNavigation();
  const biLogger = useBiLogger();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;
  const isLoggedIn = useIsLoggedIn();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);

  const handleNext = async () => {
    biLogger.actionClicked({
      action: ACTION.THEME_SELECTOR_NEXT,
      button_name: BUTTON_NAME.NEXT,
      value: selectedThemeColor || '',
    });

    if (shouldSelectThemeFirst && !isLoggedIn) {
      const url = new URL(window.location.href);
      window.location.href = `${url.origin}${APP_ROOT_URL}${STORE_NAME_URL}${url.search}`;
      return;
    }

    navigate(STORE_NAME_URL);
  };

  return {
    handleNext,
  };
};
